import { fetchData } from '@umu/umu-fetch';
import { IResponse } from '@umu/umu-types';
import { TEMPLATE_API as API } from '../api/template';
import { ITemplateListInfo, ITemplateParams, IMultiCapabilityTemplateInfo } from '../interface/multiCapabilityTemplate';
import { defaultListData } from '../dataFlow/multiCapabilityTemplate';
/**
 * 获取评价维度列表信息
 */
const getTemplateListByType = (params: ITemplateParams): Promise<ITemplateListInfo> => {
    return fetchData(API.CAPABILITY_TEMPLATE_LIST, params, { silent: true }).then(
        (res: IResponse<ITemplateListInfo>) => {
            return res.data && !Array.isArray(res.data) ? res.data : defaultListData;
        },
        () => {
            return defaultListData;
        },
    );
};
const delTemplateById = (params: ITemplateParams): Promise<boolean> => {
    return fetchData(API.CAPABILITY_TEMPLATE_DEL, params).then(
        (res: IResponse<{ ret: number }>) => {
            return res.data ? Number(res.data.ret) > 0 : false;
        },
        () => {
            return false;
        },
    );
};

const getTemplateQuestionListByType = (params: ITemplateParams): Promise<IMultiCapabilityTemplateInfo> => {
    return fetchData(API.CAPABILITY_TEMPLATE_QUESTION, params).then(
        (res: IResponse<{ ret: number }>) => {
            return res.data ? res.data : { list: [] };
        },
        () => {
            return { list: [] };
        },
    );
};
const saveTemplateQuestionListByType = (params: any): Promise<{ isSuccess: boolean }> => {
    return fetchData(API.SAVE_CAPABILITY_TEMPLATE_QUESTION, params).then(
        (res: IResponse<{ id: string }>) => {
            return {
                isSuccess: !!res.data?.id,
            };
        },
        () => {
            return {
                isSuccess: false,
            };
        },
    );
};

export { getTemplateListByType, saveTemplateQuestionListByType, getTemplateQuestionListByType, delTemplateById };
